<template>
	<div class="certificate-list">
		<b-card header-tag="header" footer-tag="footer" class="hidden-print">
			<transition name="slide" mode="out-in">
				<div class="filter-frame bg-light p-2">
					<b-row>
						<b-col sm="2">
							<b-input-group size="sm">
								<date-picker
									v-model="fromDate"
									lang="ru"
									:placeholder="$t('certificate.fromDate')"
									value-type="format"
									format="DD-MM-YYYY"
								></date-picker>
							</b-input-group>
						</b-col>
						<b-col sm="2">
							<b-input-group size="sm">
								<date-picker
									v-model="toDate"
									lang="ru"
									:placeholder="$t('certificate.toDate')"
									value-type="format"
									format="DD-MM-YYYY"
								></date-picker>
							</b-input-group>
						</b-col>
						<b-col sm="3">
							<b-row>
								<b-col cols="5" align="center">
									<h5><b>{{ $t('promo-to-product.department') }}:</b></h5>
								</b-col>
								<b-col>
									<h5>{{ depName }}</h5>
								</b-col>
							</b-row>
<!--							<multiselect-->
<!--								v-model="selectedDepartment"-->
<!--								v-if="isSales || isSalesByItem"-->
<!--								:options="getDepartmentsLocal()"-->
<!--								:multiple="true"-->
<!--								:group-select="true"-->
<!--								track-by="id"-->
<!--								label="name"-->
<!--								:show-labels="false"-->
<!--								:allow-empty="true"-->
<!--								class="multiselect-pricing"-->
<!--							>-->
<!--								<span-->
<!--									slot="noResult">Oops! No elements found. Consider changing the search query.</span>-->
<!--							</multiselect>-->
<!--							<multiselect-->
<!--								v-model="zReportDep"-->
<!--								v-else-->
<!--								@input="fetchCashboxList"-->
<!--								:options="myDepartments"-->
<!--								:multiple="false"-->
<!--								:group-select="true"-->
<!--								track-by="id"-->
<!--								label="name"-->
<!--								:show-labels="false"-->
<!--								:allow-empty="true"-->
<!--								class="multiselect-pricing"-->
<!--							>-->
<!--								<span-->
<!--									slot="noResult">Oops! No elements found. Consider changing the search query.</span>-->
<!--							</multiselect>-->
						</b-col>
						<b-col v-if="isSales || isSalesByItem" cols="3">
							<b-row>
								<b-col cols="5" align="center">
									<h5><b>{{ $t('kassa.nomer') }}:</b></h5>
								</b-col>
								<b-col>
									<h5>{{ cashName }}</h5>
								</b-col>
							</b-row>
<!--							<multiselect-->
<!--								:group-select="true"-->
<!--								:show-labels="false"-->
<!--								:allow-empty="true"-->
<!--								class="multiselect-pricing"-->
<!--								v-model="cashboxSaleId"-->
<!--								:plain="false"-->
<!--								:options="cashboxSaleList"-->
<!--								:multiple="false"-->
<!--								size="sm"-->
<!--								label-for="Position"-->
<!--								:required="true"-->
<!--								track-by="id"-->

<!--								label="name"-->
<!--							>-->
<!--								<template slot="first">-->
<!--									<option :value="null" disabled>-->
<!--										&#45;&#45;{{ $t('posSettings.selectMessage') }}&#45;&#45;-->
<!--									</option>-->
<!--								</template>-->
<!--							</multiselect>-->
<!--						</b-col>-->
<!--						<b-col cols="3" v-else-if="!isReport16">-->
<!--							<multiselect-->
<!--								:group-select="true"-->
<!--								:show-labels="false"-->
<!--								:allow-empty="true"-->
<!--								class="multiselect-pricing"-->
<!--								v-model="cashboxId"-->
<!--								:plain="false"-->
<!--								:options="cashboxList"-->
<!--								:multiple="false"-->
<!--								size="sm"-->
<!--								label-for="Position"-->
<!--								:required="true"-->
<!--								track-by="id"-->

<!--								label="name"-->
<!--							>-->
<!--								<template slot="first">-->
<!--									<option :value="null" disabled>-->
<!--										&#45;&#45;{{ $t('posSettings.selectMessage') }}&#45;&#45;-->
<!--									</option>-->
<!--								</template>-->
<!--							</multiselect>-->
						</b-col>
						<b-col cols="3" v-else>
							<b-form-input placeholder="Наименование" v-model="name"/>
						</b-col>
						<b-col sm="2" v-if="isSales || isSalesByItem">
							<b-input-group>
								<b-form-input :placeholder="$t('sale.saleNumber')" v-model="saleNumber" type="text"></b-form-input>
							</b-input-group>
						</b-col>
						<b-col sm="2" v-if="isSales || isSalesByItem">
							<b-form-select v-model="checkStatus">
								<option value="QAYTARISH">{{ $t('pos.return') }}</option>
								<template slot="first">
									<option :value="null">-- {{ $t('promo-to-product.status') }} --</option>
								</template>
							</b-form-select>
						</b-col>
						<b-col v-if="isSalesByItem" cols="3">
							<b-input-group>
								<b-form-input :placeholder="$t('incomes.create.product')" v-model="itemName" type="text"></b-form-input>
							</b-input-group>
						</b-col>
						<b-col v-if="isSalesByItem" cols="2">
							<b-input-group>
								<b-form-input :placeholder="$t('goods.special-barcode')" v-model="barcode" type="text"></b-form-input>
							</b-input-group>
						</b-col>
						<b-col v-if="isSalesByItem" cols="3">
							<b-input-group>
								<b-form-input :placeholder="$t('goods.barcode')" v-model="multiBarcode" type="text"></b-form-input>
							</b-input-group>
						</b-col>
						<b-col v-if="isSalesByItem" cols="2">
							<b-input-group>
								<b-form-input :placeholder="$t('goods.artikul')" v-model="artikul" type="text"></b-form-input>
							</b-input-group>
						</b-col>
						<b-col sm="1" :class="isSales ? 'pb-2' : 'pb-3' && isSalesByItem ? 'mt-2' : ''">
							<b-button variant="dark" @click="search">
								<span><i class="fa fa-search"></i></span>
							</b-button>
						</b-col>
						<b-col v-if="isSalesByItem" sm="2" class="mt-2">
							<b-form-select v-model="salesByItemLimit1">
								<option value="20">20</option>
								<option value="50">50</option>
								<option value="100">100</option>
								<option value="200">200</option>
								<option value="all">Все</option>
							</b-form-select>
						</b-col>
						<b-col v-else-if="isSales" sm="2">
							<b-form-select v-model="perPage1">
								<option value="20">20</option>
								<option value="50">50</option>
								<option value="100">100</option>
								<option value="200">200</option>
								<option value="all">Все</option>
							</b-form-select>
						</b-col>
					</b-row>
				</div>
			</transition>
			<div slot="header" class="top-card">
				<span>
					<b-button variant="primary" @click="$router.go(-1)" class="fa fa-arrow-left mr-3" style="display: inline-block"><b class="ml-2">В меню</b></b-button>
				  <h5 v-if="isSales" style="display: inline-block">{{ $t('sidebar.sales.title') }}</h5>
				  <h5 v-else-if="isSalesByItem" style="display: inline-block">Продажи по товарам</h5>
				  <h5 v-else-if="isZReports" style="display: inline-block">{{ $t('zOtchet.list') }}</h5>
<!--				  <h5 v-else style="display: inline-block">{{ 'Проданные товары' }}</h5>-->
				</span>
				<b-form-radio-group
					id="btn-radios-2"
					v-model="selected"
					:options="options"
					buttons
					button-variant="outline-primary"
					size="sm"
					name="radio-btn-outline"
				></b-form-radio-group>
			</div>
			<div class="table-responsive table-wrapper">
				<b-table
					v-if="isSales || isZReports"
					class="generalTableClass"
					hover="hover"
					striped="striped"
					bordered="bordered"
					small="small"
					fixed="fixed"
					:loading="loading"
					:items="getTableItems"
					responsive
					:fields="computedFields"
					show-empty
				>
					<template slot="empty">
						<h4>{{ $t('empty') }}</h4>
					</template>
					<template slot="id" slot-scope="data">
						<strong>{{ data.index + 1 }}</strong>
					</template>
					<template slot="status" slot-scope="data">
						<strong v-if="data.item.action == 'QAYTARISH'">{{ $t('pos.return') }}</strong>
						<strong v-else-if="!hasDeptPayment(data.item.payments) && !hasSponsorshipPayment(data.item.payments) && data.item.status === 'READY'">{{ $t('sidebar.sales.ready') }}</strong>
						<template v-if="hasDeptPayment(data.item.payments)">
							<strong>{{ $t('xAtchot.debt') }}:</strong><br/>
							<span>{{data.item.payments.find(el => el.paymentTypeCode == 'QARZGA').value | currency({symbol: returnCurrencyNameForDep(data.item.shopId), fractionCount: 2, symbolPosition: 'back'}) }}</span>
						</template>
						<template v-if="hasSponsorshipPayment(data.item.payments)">
							<strong>{{ $t('sidebar.sales.sponsor') }}:</strong><br/>
							<span>{{data.item.payments.find(el => el.paymentTypeCode == 'HOMIYLIK').value | currency({symbol: returnCurrencyNameForDep(data.item.shopId), fractionCount: 2, symbolPosition: 'back'}) }}</span>
						</template>
					</template>
					<template slot="itemsCount" slot-scope="data">
						<strong>{{ saleItemsCount(data.item) }}</strong>
						<!--						<strong v-if="checkStatus == 'QAYTARISH'">{{ data.item.totalCount }}</strong>-->
						<!--						<strong v-else>{{ saleItemsCount(data.item.saleItems) }}</strong>-->
					</template>
					<template slot="zReportStatus" slot-scope="data">
						<b-badge variant="success" v-if="data.item.open" style="padding: 5px 10px;">Открыть</b-badge>
						<b-badge variant="info" v-else style="padding: 5px 10px;">Закрыто</b-badge>
					</template>
					<template slot="amountOfPaymentUzs" slot-scope="data">
						{{
							data.item.amountOfPaymentUzs | currency({
								symbol:
									returnCurrencyNameForDep(data.item.shopId), fractionCount: 2, symbolPosition: 'back'
							})
						}}
					</template>
					<template slot="amountOfAfterPromoUzs" slot-scope="data">
						<strong>
							{{
								data.item.amountOfAfterPromoUzs | currency({
									symbol:
										returnCurrencyNameForDep(data.item.shopId),
									fractionCount: 2,
									symbolPosition: 'back'
								})
							}}
						</strong>
					</template>
					<template slot="array" slot-scope="data">
						<strong v-for="(i, index) in data.item.paymentMap.CASH">
							{{i.value}} {{i.currencyCode}} <br>
						</strong>
						<strong v-for="(i, index) in data.item.paymentMap.BANK_CARD">
							<p style="color: #4DBD74">{{i.paymentTypeCode}}</p> {{i.value}} {{i.currencyCode}} <br>
						</strong>
					</template>
					<template slot="actions" slot-scope="data">
						<b-link @click.prevent="editBtn(data, 'forModal')">
							<i class="fa fa-eye editBtn"></i>
						</b-link>
						<b-link v-if="isSales" @click.prevent="printCheck(data)">
							<i class="fa fa-print editBtn"></i>
						</b-link>
					</template>
				</b-table>
				<table v-if="isSalesByItem" class="table table-bordered table-striped table-hover">
					<thead>
					<tr>
						<th class="text-center">№</th>
						<th class="text-center">{{ $t('sale.saleNumber') }}</th>
						<th class="text-center">{{ $t('sale.saleDate') }}</th>
						<th class="text-center">{{ $t('sale.shopName') }}</th>
						<th class="text-center">{{ $t('POS №') }}</th>
						<th class="text-center">{{ $t('sale.status') }}</th>
						<th class="text-center">{{ $t('sale.kol-vo') }}</th>
						<th class="text-center">{{ $t('pos.sum') }}</th>
						<th class="text-center">{{ $t('sale.sum-skidka') }}</th>
						<th class="text-center">{{ $t('pos.product') }}</th>
						<th class="text-center">{{ $t('goods.special-barcode') }}</th>
						<th class="text-center">{{ $t('goods.barcode') }}</th>
						<th class="text-center">{{ $t('goods.artikul') }}</th>
					</tr>
					</thead>
					<tbody v-if="salesByItemList.length > 0">
					<tr v-for="(item, index) in salesByItemList" :key="`items-${index}`">
						<td class="text-center">{{ index+1 }}</td>
						<td class="text-center">{{ item.saleNumber }}</td>
						<td class="text-center">{{ item.updateDate }}</td>
						<td class="text-center">{{ item.shopName }}</td>
						<td class="text-center">{{ item.cashboxName }}</td>
						<td class="text-center">
							<strong v-if="item.action == 'QAYTARISH'">{{ $t('pos.return') }}</strong>
							<strong v-else>{{ $t('sidebar.sales.ready') }}</strong>
						</td>
						<td class="text-center">{{ item.count }}</td>
						<td class="text-center">{{ item.priceUzs }}</td>
						<td class="text-center">{{ item.priceAfterUzs }}</td>
						<td>{{ item.itemName }}</td>
						<td class="text-center">{{ item.barcode }}</td>
						<td class="text-center">{{ item.multiBarcode }}</td>
						<td class="text-center">{{ item.artikul }}</td>
					</tr>
					</tbody>
					<tbody v-else>
					<tr>
						<td colspan="13" class="text-center"><b>{{ $t('empty') }}</b></td>
					</tr>
					</tbody>
				</table>
				<table v-if="isReport16" class="b-table table-hover table-bordered" style="font-size: 11px; width: 100%">
					<thead>
					<tr>
						<th class="text-center" style="font-size: 10px; width: 3%">№</th>
						<th class="text-center" style="font-size: 10px; width: 15%">Спецкод</th>
						<th class="text-center" style="font-size: 10px; width: 25%">Наименование</th>
						<th class="text-center" style="font-size: 10px; width: 15%">Остаток</th>
						<th class="text-center" style="font-size: 10px; width: 15%">Продано</th>
						<th class="text-center" style="font-size: 10px; width: 15%">Суммы по продажной</th>
						<th class="text-center" style="font-size: 10px; width: 15%">Прод. в суммах</th>
					</tr>
					</thead>
					<tbody v-for="(item, index) in report16" :key="`items-${index}`" style="padding: 0; margin: 0">
					<tr class="text-left">
						<td colspan="7"><b>Группа: </b>{{ item.groupName }}</td>
					</tr>
					<tr class="text-center" v-for="(sub, i) in item.subGroups" style="padding: 0; margin: 0">
						<td colspan="7">
							<b>Подгруппа: </b><i>{{ sub.supGroupName }}</i>
							<table class="b-table table-striped table-hover table-bordered" style="width: 100%; padding: 0; margin: 0">
								<tr v-for="(tmp, ind) in sub.saleItems" :key="`saleItems-${i}`">
									<td class="text-center" style="font-size: 10px; width: 3%">{{ ind+1 }}</td>
									<td class="text-center" style="font-size: 10px; width: 15%">{{ tmp.barcode }}</td>
									<td class="text-left" style="font-size: 10px; width: 25%">{{ tmp.itemName }}</td>
									<td class="text-center" style="font-size: 10px; width: 15%">{{ tmp.remaning }}</td>
									<td class="text-center" style="font-size: 10px; width: 15%">{{ tmp.saleCount }}</td>
									<td class="text-center" style="font-size: 10px; width: 15%">{{ tmp.price }}</td>
									<td class="text-center" style="font-size: 10px; width: 15%">{{ tmp.priceUzs.toFixed(2) }}</td>
								</tr>
								<tr>
									<td colspan="3" class="text-right"><b>Итого: </b></td>
									<td class="text-center"><b>{{ sumRemaining(sub) }}</b></td>
									<td class="text-center"><b>{{ sumSaleCount(sub) }}</b></td>
									<td class="text-center"><b>{{ sumPrice(sub).toFixed(2) }}</b></td>
									<td class="text-center"><b>{{ sumPriceUzs(sub).toFixed(2) }}</b></td>
								</tr>
							</table>
						</td>
					</tr>
					<tr>
						<td colspan="3" class="text-right"><b>Итого по {{ item.groupName }}:</b></td>
						<td class="text-center"><b>{{ itogoSumRemaining(item) }}</b></td>
						<td class="text-center"><b>{{ itogoSumSaleCount(item) }}</b></td>
						<td class="text-center"><b>{{ itogoSumPrice(item).toFixed(2) }}</b></td>
						<td class="text-center"><b>{{ itogoSumPriceUzs(item).toFixed(2) }}</b></td>
					</tr>
					</tbody>
					<tr v-if="report16.length > 0">
						<td colspan="3" class="text-right"><b>Всего:</b></td>
						<td class="text-center"><b>{{ vsegoRemaining(report16) }}</b></td>
						<td class="text-center"><b>{{ vsegoSaleCount(report16) }}</b></td>
						<td class="text-center"><b>{{ vsegoPrice(report16).toFixed(2) }}</b></td>
						<td class="text-center"><b>{{ vsegoPriceUzs(report16).toFixed(2) }}</b></td>
					</tr>
					<tr v-if="loading">
						<td colspan="7" class="text-center">
							<b-spinner small class="mr-2"/><strong>Loading...</strong>
						</td>
					</tr>
				</table>
				<div v-if="getTableItems && isSales">
					<download-excel
						size="sm"
						class="btn btn-success"
						:data="itemsForExcel"
						worksheet="My Worksheet"
						name="Excel"
					></download-excel>
					<br/>
					<br/>
				</div>
				<div v-else-if="salesByItemList.length > 0 && isSalesByItem">
					<download-excel
						size="sm"
						class="btn btn-success"
						:data="saleByItemsForExcel"
						worksheet="Продажи по товарам"
						name="Excel*"
					></download-excel>
					<br/>
					<br/>
				</div>
				<nav v-if="selected == 'salesByItem'">
					<b-pagination
						size="sm"
						:total-rows="salesByItemTotal"
						:per-page="salesByItemLimit"
						v-model="salesByItemPage"
						:prev-text="$t('pagination.prev')"
						:next-text="$t('pagination.next')"
						hide-goto-end-buttons
					/>
				</nav>
				<nav>
					<div v-if="selected=='sales'">
						<b-pagination
							size="sm"
							:total-rows="getSales.total"
							:per-page="perPage"
							v-model="currentPage"
							:prev-text="$t('pagination.prev')"
							:next-text="$t('pagination.next')"
							hide-goto-end-buttons
						/>
					</div>
					<div v-if="selected=='zReports'">
						<b-pagination
							size="sm"
							:total-rows="zReportsTotal"
							:per-page="perPage"
							v-model="currentPage"
							:prev-text="$t('pagination.prev')"
							:next-text="$t('pagination.next')"
							hide-goto-end-buttons
						/>
					</div>
				</nav>
				<div v-if="loader" class="spinner-wrapper">
					<b-spinner variant="primary"></b-spinner>
				</div>
			</div>
		</b-card>
		<!-- CHECK TO PRINT -->
		<pos-check></pos-check>

		<b-modal
			id="saleViewModal"
			ref="saleAndZReportModal"
			size="xl"
			hide-footer
			hide-header
			:no-close-on-esc="true"
			:no-close-on-backdrop="true"
			class="hidden-print body-padding-0"
		>
			<sale-view
				v-if="isSales"
				:item="item"
				@close="closeSaleAndZReportModal"
				:currencyForSaleView="currencyForSaleView"
			></sale-view>
			<x-and-z-report
				v-else-if="zReportShow"
				is-z-report
				is-from-z-reports-page
				:z-report-id="currentItemId"
				:dep-id="currentItemDepId"
				@close="closeSaleAndZReportModal"
			></x-and-z-report>
		</b-modal>
		<vs-sidebar
			position-right
			parent="body"
			default-index="1"
			color="primary"
			class="create-modal priceSidebar hidden-print"
			spacer
			v-model="activeSidebar"
			:click-not-close="true"
		>
			<RefundEdit :item="item" @closeSidebar="closeSidebar" @updateSaleRefound="updateSaleRefound"></RefundEdit>
		</vs-sidebar>
	</div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import PosCheck from '../pos/components/PosCheck';
import ApiService from "../../../services/api.service";

import VisibleColumns from "../../warehouse-management/warehouse/blocks/VisibleColumns";
import MaskedInput from "vue-masked-input";
import Multiselect from "vue-multiselect";
import RefundEdit from "../sales/SaleEdit";
import {
	DxDataGrid,
	DxColumn,
	DxPaging,
	DxPager
} from "devextreme-vue/data-grid";
import RefundService from "../../../services/refund.service";
import XAndZReport from "@/views/point-of-sale/pos/components/Xreport/XAndZReport";
import {
	validators
} from "../../warehouse-management/wh-documents/mixins/validators";
import SaleView from "../sales/SaleView";
import ReportService from "../../analytics/otchot/report.service";

export default {
	mixins: [validators],
	components: {
		VisibleColumns,
		XAndZReport,
		DxDataGrid,
		DxColumn,
		DxPaging,
		DxPager,
		MaskedInput,
		Multiselect,
		RefundEdit,
		SaleView,
		PosCheck
	},

	data() {
		return {
			loading: false,
			validators: {},
			selectedDepForSearch: null,
			cashboxId: null,
			cashboxSaleId: null,
			cashboxList: [],
			cashboxSaleList: [],
			salesByItemList: [],
			currency: [
				'дол',
				'евро',
				'фунты',
				'сумы',
				'рос'
			],
			report16: [],
			name: '',
			salesByItemTotal: 0,
			salesByItemLimit: 20,
			salesByItemLimit1: 20,
			salesByItemPage: 1,
			zReportShow: false,
			currentItemId: null,
			currentItemDepId: null,
			dataSource: null,
			json_fields: {
				ID: "id",
				"Номер чека": "checkNumber",
				"Дата продажи": "updateDate",
				Отдел: "department",
				Статус: "status",
				"Кол-во товаров": "qtyItems",
				Сумма: "skidka",
				"Сумма со скидкой": "date",
				Клиент: "client"
			},
			itemName: '',
			barcode: '',
			multiBarcode: '',
			artikul: '',
			loader: true,
			items: [],
			activeEditSidebar: false,
			currentPage: 1,
			zReportGetById: {},
			perPage: 20,
			perPage1: 20,
			fromDate: "",
			toDate: "",
			check: null,
			isDropped: false,
			popoverShow: false,
			selectedDepartment: [],
			zReportDep: null,
			saleNumber: "",
			activeSidebar: false,
			item: [],
			currencyForSaleView: "",
			currencyForZReportView: "",
			currentZReport: {},
			contrAgent: [],
			checkStatus: null,
			selected: "sales",
			options: [
				{
					text: this.$t("sidebar.sales.title"),
					value: "sales"
				},
				{
					text: 'Продажи по товарам',
					value: "salesByItem"
				},
				{
					text: this.$t("zOtchet.list"),
					value: "zReports"
				},
				// {
				// 	text: 'Проданные товары',
				// 	value: "report16"
				// }
			]
		};
	},
	watch: {
		salesByItemLimit1: {
			handler(t) {
				if (t == 'all') {
					this.salesByItemLimit = this.salesByItemTotal
				} else {
					this.salesByItemLimit = t
				}
				this.search();
			}
		},
		perPage1: {
			handler(t) {
				if (t == 'all') {
					this.perPage = this.getSales.total
				} else {
					this.perPage = t
				}
				this.search();
			}
		},
		salesByItemPage: {
			handler(t) {
				this.search();
			}
		},
		currentPage: {
			async handler() {
				if (this.selected == "sales" || this.selected=='salesByItem') {
					await this.search();
				}
				if (this.selected == "zReports") {
					await this.search();
				}
			}
		},
		'selectedDepartment': {
			handler(e) {
				if (e) {
					this.cashboxSaleList = []
					e.forEach(dep => {
						ApiService.get(`cashbox/get/by-dep-id/${dep.id}`).then(res => {
							res.data.forEach(tmp => {
								this.cashboxSaleList.push(tmp)
							})
						})
					})
				}
			}
		}
	},
	methods: {
		...mapActions('departments', ['fetchMyDepartments']),
		fetchCashboxList() {
			if (this.zReportDep) {
				ApiService.get(`cashbox/get/by-dep-id/${this.zReportDep.id}`)
					.then(res => {
						this.cashboxList = res.data
						for (let i = 0; i < res.data.length; i++)
							this.check = res.data[i].id
					})
			}
		},
		getZReports1List() {
		},
		columnListener($event) {
			this.columns = $event
		},
		async removePageSizeStyle() {
			var el = document.getElementById('stylePrintSizeId');
			if (el) {
				el.remove(); // Removes the div with the 'stylePrintSizeId' id
			}
		},
		async setPageSizeStyle(sizeValue) {
			var css = `@page { size: ${sizeValue}; }`,
				head = document.head || document.getElementsByTagName('head')[0],
				style = document.createElement('style');

			style.type = 'text/css';
			style.media = 'print';
			style.id = 'stylePrintSizeId';

			if (style.styleSheet) {
				style.styleSheet.cssText = css;
			} else {
				style.appendChild(document.createTextNode(css));
			}

			head.appendChild(style);
		},
		async printCheck(data) {
			await this.$store.commit('pos/setCurrentSaleForCheck', data.item);
			await this.removePageSizeStyle();
			await this.setPageSizeStyle('portrait');
			window.print();
		},
		closeSaleAndZReportModal() {
			this.$refs.saleAndZReportModal.hide();
			this.zReportShow = false
		},
		hasSponsorshipPayment(payments) {
			let foundIndex = payments.findIndex(
				payment => payment.paymentTypeCode == "HOMIYLIK"
			);
			if (foundIndex > -1) {
				return true;
			}
			return false;
		},
		hasDeptPayment(payments) {
			let foundIndex = payments.findIndex(
				payment => payment.paymentTypeCode == "QARZGA"
			);
			if (foundIndex > -1) {
				return true;
			}
			return false;
		},
		getamountOfSumma(el) {
			return (
				el.amountOfPaymentUzs.toFixed(2) +
				" " +
				this.returnCurrencyNameForDep(
					el.payments.length > 0 ? el.payments[0].paymentTypeId : {}
				)
			);
		},
		getamountOfDiscountSumma(el) {
			return (
				el.amountOfAfterPromoUzs.toFixed(2) +
				" " +
				this.returnCurrencyNameForDep(
					el.payments.length > 0 ? el.payments[0].paymentTypeId : {}
				)
			);
		},
		getPaymentStatus(el) {
			for (let i = 0; i < el.payments.length; i++) {
				if (
					el.payments[i].paymentTypeCode == "QARZGA" &&
					el.payments.length >= 1
				) {
					return (
						this.$t("xAtchot.debt") +
						" " +
						el.payments[i].value +
						" " +
						this.returnCurrencyNameForDep(el.payments[i].paymentTypeId)
					);
				}
				if (
					el.payments[i].paymentTypeCode == "HOMIYLIK" &&
					el.payments.length >= 1
				) {
					return (
						this.$t("sidebar.sales.sponsor") +
						" " +
						el.payments[i].value +
						" " +
						this.returnCurrencyNameForDep(el.payments[i].paymentTypeId)
					);
				}
				if (
					el.payments.length <= 1 &&
					el.payments[i].paymentTypeCode != "QARZGA" &&
					el.payments[i].paymentTypeCode != "HOMIYLIK"
				) {
					return this.$t("sidebar.sales.ready");
				}
			}
		},
		returnCurrencyNameForDep(shopId) {
			if (this.getDepartments.length > 0) {
				let tempForDep = this.getDepartments.find(dep => {
					return dep.id == shopId;
				});
				if (tempForDep) {
					return tempForDep.currencyName;
				} else {
					return this.userDepCurrencyName;
				}
			} else {
				return this.userDepCurrencyName;
			}
		},

		...mapActions("refunds", [
			"getSaleLists",
			"getZreportsList",
			"getItemsFromId",
			"setRefound",
			"fetchRetailReturnSales"
		]),
		...mapActions("zetReport", ["getZReportById"]),
		...mapActions("prices", ["getDepartmentList"]),
		...mapActions("contragents", ["fetchContragents"]),
		async search() {
			if (this.selected == "sales") {
				if (this.$route.params.depId && this.$route.params.cashId) {
					this.loader = true;
					this.loading = true;
					this.isDropped = true;
					const departments = [this.$route.params.depId]
					const contrAgentList = this.contrAgent.map(contragent => {
						return contragent.id;
					});
					let data = {
						page: this.currentPage,
						limit: this.perPage,
						startDate: this.fromDate,
						endDate: this.toDate,
						saleNumber: this.saleNumber,
						action: this.checkStatus,
						department: departments,
						cashboxId: this.$route.params.cashId,
						contragent: contrAgentList,
						sort: {saleNumber: '', saleDate: ''}
					};
					await this.getSaleLists(data);
					// }
					this.loader = false;
					this.loading = false;
				} else {
					this.$vs.notify({
						text: "Выберите Подразделение",
						color: "warning",
						icon: "close",
						position: "top-right"
					});
					return 0;
				}
			} else if (this.selected == "salesByItem") {
				if (this.$route.params.depId && this.$route.params.cashId) {
					this.loader = true;
					this.loading = true;
					this.isDropped = true;
					const departments = [this.$route.params.depId]
					const contrAgentList = this.contrAgent.map(contragent => {
						return contragent.id;
					});
					let data = {
						page: this.salesByItemPage,
						limit: this.salesByItemLimit,
						startDate: this.fromDate,
						endDate: this.toDate,
						saleNumber: this.saleNumber,
						action: this.checkStatus,
						department: departments,
						cashboxId: this.$route.params.cashId,
						contragent: contrAgentList,
						itemName: this.itemName,
						barcode: this.barcode,
						multiBarcode: this.multiBarcode,
						artikul: this.artikul,
						sort: {saleNumber: '', saleDate: '', name: '', barcode: ''}
					};
					await RefundService.getSaleByItemList(data).then(res => {
						this.salesByItemList = res.data.items
						this.salesByItemTotal = res.data.total
					}).catch(e => {
						this.$vs.notify({
							title: e.response.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					})
					this.loader = false;
					this.loading = false;
				} else {
					this.$vs.notify({
						text: "Выберите Подразделение",
						color: "warning",
						icon: "close",
						position: "top-right"
					});
					return 0;
				}
			} else if (this.selected == 'zReports') {
				if (this.$route.params.depId && this.$route.params.cashId) {
					this.loading = true
					if (this.fromDate == "") {
						this.fromDate = null;
					}
					if (this.toDate == "") {
						this.toDate = null;
					}
					await this.getZreportsList({
						departmentId: this.$route.params.depId,
						cashboxId: this.$route.params.cashId,
						startDate: this.fromDate,
						endDate: this.toDate,
						page: this.currentPage,
						limit: 20,
						sort: {start: '', end: '', dep: ''}
					});
					this.loading = false
				} else {
					this.$vs.notify({
						text: "Выберите Подразделение",
						color: "warning",
						icon: "close",
						position: "top-right"
					});
					return 0;
				}
			} else {
				this.loading = true
				if (this.$route.params.depId && this.fromDate && this.toDate) {
					let data = {
						startDate: this.fromDate,
						endDate: this.toDate,
						deps: this.$route.params.depId,
						allDeps: false,
						groups: [],
						subGroups: [],
						groupNots: [],
						subGroupNots: [],
						value: this.name
					}
					await ReportService.getReportItems4(data).then(res => {
						this.loading = false
						this.report16 = res.data
					}).catch(e => {
						this.loading = false
						this.$vs.notify({
							title: this.$t('words.error'),
							text: e,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					})
				} else {
					this.loading = false
					this.$vs.notify({
						text: "Выберите Подразделение с периодом",
						color: "warning",
						icon: "close",
						position: "top-right"
					});
					return 0;
				}
			}
		},
		sumRemaining(item) {
			let sum = 0
			item.saleItems.forEach(tmp => {
				sum+=tmp.remaning
			})
			return sum
		},
		sumSaleCount(item) {
			let sum = 0
			item.saleItems.forEach(tmp => {
				sum+=tmp.saleCount
			})
			return sum
		},
		sumPrice(item) {
			let sum = 0
			item.saleItems.forEach(tmp => {
				sum+=tmp.price
			})
			return sum
		},
		sumPriceUzs(item) {
			let sum = 0
			item.saleItems.forEach(tmp => {
				sum+=tmp.priceUzs
			})
			return sum
		},
		itogoSumRemaining(item) {
			let itog = 0
			item.subGroups.forEach(ite => {
				let sum = 0
				ite.saleItems.forEach(t => {
					sum+=t.remaning
				})
				itog+=sum
			})
			return itog
		},
		itogoSumSaleCount(item) {
			let itog = 0
			item.subGroups.forEach(ite => {
				let sum = 0
				ite.saleItems.forEach(t => {
					sum+=t.saleCount
				})
				itog+=sum
			})
			return itog
		},
		itogoSumPrice(item) {
			let itog = 0
			item.subGroups.forEach(ite => {
				let sum = 0
				ite.saleItems.forEach(t => {
					sum+=t.price
				})
				itog+=sum
			})
			return itog
		},
		itogoSumPriceUzs(item) {
			let itog = 0
			item.subGroups.forEach(ite => {
				let sum = 0
				ite.saleItems.forEach(t => {
					sum+=t.priceUzs
				})
				itog+=sum
			})
			return itog
		},
		vsegoRemaining(tmp) {
			let vsego = 0
			tmp.forEach(item => {
				let itog = 0
				item.subGroups.forEach(ite => {
					let sum = 0
					ite.saleItems.forEach(t => {
						sum+=t.remaning
					})
					itog+=sum
				})
				vsego+=itog
			})
			return vsego
		},
		vsegoSaleCount(tmp) {
			let vsego = 0
			tmp.forEach(item => {
				let itog = 0
				item.subGroups.forEach(ite => {
					let sum = 0
					ite.saleItems.forEach(t => {
						sum+=t.saleCount
					})
					itog+=sum
				})
				vsego+=itog
			})
			return vsego
		},
		vsegoPrice(tmp) {
			let vsego = 0
			tmp.forEach(item => {
				let itog = 0
				item.subGroups.forEach(ite => {
					let sum = 0
					ite.saleItems.forEach(t => {
						sum+=t.price
					})
					itog+=sum
				})
				vsego+=itog
			})
			return vsego
		},
		vsegoPriceUzs(tmp) {
			let vsego = 0
			tmp.forEach(item => {
				let itog = 0
				item.subGroups.forEach(ite => {
					let sum = 0
					ite.saleItems.forEach(t => {
						sum+=t.priceUzs
					})
					itog+=sum
				})
				vsego+=itog
			})
			return vsego
		},
		saleItemsCount(item) {
			let count = 0;
			if (item.saleItems && item.saleItems.length > 0) {
				item.saleItems.forEach(sale => {
					count += sale.count;
				});
			}
			if (item.productItems && item.productItems.length > 0) {
				item.productItems.forEach(sale => {
					count += sale.count;
				});
			}
			return count;
		},
		showEditPopover() {
			this.popoverShow = true;
		},
		getDepartmentsLocal() {
			return this.getDepartments;
		},
		openSearchForm() {
			this.isDropped = !this.isDropped;
		},
		closeEditSidebar() {
			this.activeEditSidebar = false;
		},
		async editBtn(data, forText = "refund") {
			if (forText !== "forModal") {
				this.activeSidebar = true;
			}
			if (this.selected == "zReports") {
				this.zReportShow = true
				this.currencyForZReportView = this.returnCurrencyNameForDep(
					data.item.companyDepartmentId
				);
				let payload = {
					zReportId: data.item.id,
					depId: data.item.companyDepartmentId,
					cashboxId: data.item.cashboxId
				};
				this.currentItemId = data.item.id
				this.currentItemDepId = data.item.companyDepartmentId
				await this.getZReportById(payload);
			} else {
				if (this.checkStatus == "QAYTARISH") {
					await ApiService.get(`/sale/get/${data.item.id}`).then(res => {
						data.item.saleItems = res.data.saleItems ? res.data.saleItems : []
						data.item.productItems = res.data.productItems ? res.data.productItems : []
						this.item = data.item
					}).catch(e => {
						return false
					})
					// await this.getSaleById(data.item.id);
					// this.item = this.currentSaleWithId;
				} else {
					await ApiService.get(`/sale/get/${data.item.id}`).then(res => {
						data.item.saleItems = res.data.saleItems ? res.data.saleItems : []
						data.item.productItems = res.data.productItems ? res.data.productItems : []
						this.item = data.item
					}).catch(e => {
						return false
					})
				}
			}
			this.currencyForSaleView = this.returnCurrencyNameForDep(
				data.item.shopId
			);
			this.$refs.saleAndZReportModal.show()
			this.popoverShow = false;
		},
		async updateSaleRefound(obj) {
			this.activeSidebar = false;
			await this.setRefound(obj);
			let data = {
				page: this.currentPage,
				limit: this.perPage
			};
			await this.getSaleLists(data);
		},
		closeSidebar() {
			this.activeSidebar = false;
		}
	},
	computed: {
		...mapState("pos", ["currentSaleWithId"]),
		...mapState("zetReport", ["chechboxId"]),
		...mapState("zetReport", ["zReportById"]),
		...mapState("refunds", ["zReports", "zReportsTotal"]),
		...mapState("contragents", ["contragents"]),
		...mapState(["isCashier", "userDepCurrencyName"]),
		...mapGetters("refunds", ["getSales", "getStatus"]),
		...mapGetters("prices", ["getDepartments"]),
		...mapGetters('departments', [
			'myDepartments'
		]),
		depName() {
			return localStorage.getItem('dep_name')
		},
		cashName() {
			return localStorage.getItem('cash_number')
		},
		itemsForExcel() {
			if (this.getTableItems) {
				if (this.isSales) {
					let array = [];
					let temp;
					this.getTableItems.forEach(el => {
						temp = Object.assign(
							{},
							{
								"Номер чека": el.saleNumber,
								"Дата продажи": el.saleDate,
								Отдел: el.shopName,
								Статус: this.getPaymentStatus(el),
								"Кол-во товаров": el.saleItems
									? el.saleItems.length
									: el.totalCount,
								Сумма: this.getamountOfSumma(el),
								"Сумма со скидкой": this.getamountOfDiscountSumma(el),
								Комментарии: el.comment
							}
						);
						array.push(temp);
					});
					return array;
				}
			}
		},
		saleByItemsForExcel() {
			if (this.salesByItemList) {
				if (this.isSalesByItem) {
					let array = [];
					let temp;
					this.salesByItemList.forEach(el => {
						temp = Object.assign(
							{},
							{
								"Номер чека": el.saleNumber,
								"Дата продажи": el.updateDate,
								Отдел: el.shopName,
								"POS №": el.cashboxName,
								Статус: el.action == 'QAYTARISH'?this.$t('pos.return'):this.$t('sidebar.sales.ready'),
								"Кол-во товаров": el.count,
								Сумма: el.priceUzs,
								"Сумма со скидкой": el.priceAfterUzs,
								Продукт: el.itemName,
								"Спец-код": el.barcode,
								"Штрих-код": el.multiBarcode,
								Артикул: el.artikul
							}
						);
						array.push(temp);
					});
					return array;
				}
			}
		},
		salesFields() {
			return [
				{
					key: "id",
					label: this.$t("users-l.Id"),
					class: "role_id",
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: "saleNumber",
					label: this.$t("sale.saleNumber"),
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: "updateDate",
					label: this.$t("sale.saleDate"),
					sortable: true
				},
				{
					key: "shopName",
					label: this.$t("sale.shopName"),
					sortable: true
				},
				{
					key: "cashboxName",
					label: 'POS №',
					sortable: true
				},
				{
					key: "status",
					label: this.$t("sale.status"),
					sortable: true
				},
				// {
				// 	key: "itemsCount",
				// 	label: this.$t("sale.transaction-item"),
				// 	sortable: true,
				// 	class: "textAlignCenter"
				// },
				{
					key: "amountOfPaymentUzs",
					label: this.$t("pos.sum"),
					sortable: true,
					class: "textAlignCenter"
				},
				{
					key: "amountOfAfterPromoUzs",
					label: this.$t("sale.sum-skidka"),
					sortable: true,
					class: "textAlignCenter"
				},
				// {
				// 	key: 'contragentName',
				// 	label: this.$t('sale.contragent'),
				// 	sortable: true
				// },
				// {
				// 	key: "customerName",
				// 	label: this.$t("sale.client"),
				// 	sortable: true
				// },
				// {
				// 	key: "clientAddress",
				// 	label: "Адрес доставки",
				// 	sortable: true
				// },
				// {
				// 	key: "clientPhoneNumber",
				// 	label: "Контактный номер",
				// 	sortable: true
				// },
				{
					key: "array",
					'class': 'table_actions min-60',
					label: this.$t("Оплата"),
					thStyle: { width: '15%'}
				},
				{
					key: "actions",
					'class': 'table_actions min-60',
					label: this.$t("actions.title")
				}
			];
		},
		zReportsFields() {
			return [
				{
					key: "id",
					label: "ID",
					class: "role_id",
					sortable: true
				},
				{
					key: "startDate",
					label: "Дата начала",
					sortable: true
				},
				{
					key: "endDate",
					label: "Дата окончания",
					sortable: true
				},
				{
					key: "companyDepartmentName",
					label: this.$t("sale.shopName"),
					sortable: true
				},
				{
					key: "zReportStatus",
					label: this.$t("sale.status"),
					sortable: true,
					class: "textAlignCenter"
				},
				{
					key: "actions",
					'class': 'table_actions min-60',
					label: this.$t("actions.title")
				}
			];
		},
		isSales() {
			return this.selected == "sales";
		},
		isSalesByItem() {
			return this.selected == "salesByItem";
		},
		isZReports() {
			return this.selected == "zReports";
		},
		isReport16() {
			return this.selected == "report16";
		},
		getTableItems() {
			return this.isSales ? this.getSales.items : this.zReports;
		},
		computedFields() {
			return this.isSales ? this.salesFields : this.zReportsFields;
		}
	},
	async created() {
		let userDep = this.myDepartments.find(dep => dep.id == this.userDepId)
		this.zReportDep = userDep ? Object.assign({}, userDep) : null
		await this.fetchCashboxList()
		await this.fetchMyDepartments()
		await this.getDepartmentList();
		await this.getDepartmentsLocal();
		this.loader = false;
	},
	destroyed() {
		this.$store.commit("refunds/resetSales", []);
		this.$store.commit("refunds/resetZReports");
	}
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style scoped lang="scss">
.print {
	display: none;
}

@media print {
	// @page {
	// 	size: portrait;
	// }
	.hidden-print {
		display: none;
	}
	.print {
		color: #000000;
		display: block;
	}
	.card {
		box-shadow: none;
	}
}

.editBtn {
	font-size: 14px;
	cursor: pointer;
}

.filter-frame {
	padding-bottom: 15px;
}

.slide-enter,
.slide-leave-to {
	transform: scaleY(0);
}

.certificateGenerate {
	background: transparent !important;
	border: none;
	padding: 7px;
	font-size: 16px;
}

.certificateGenerate span {
	margin-left: 5px;
}

.top-card {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.search_btn {
	width: 100%;
	display: flex;
	justify-content: flex-end;
	padding-right: 25px;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

.btn-sml {
	padding: 4px 4px;
	font-size: 9px;
	border-radius: 6px;
}

.dropdown-menu {
	font-size: 1px !important;
}

.dropdown-item i {
	color: black;
}

.card-body {
	padding: 0 !important;
}

.spinner-wrapper {
	position: absolute;
	background: rgba(32, 28, 32, 0.49);
	left: 0;
	right: 0;
	text-align: center;
	top: 0;
	bottom: 0;
	padding-top: 35px;
	z-index: 5;
}

.table-wrapper {
	position: relative;
	padding: 5px;
}

.mx-datepicker {
	width: 290px;
}
</style>
